<template>
	<div>
		<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/company/dynamic_big.png" style="width: 100%;" />
		<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/company/dynamic_big1.png" style="width: 100%;" />
		<div class="center_sun" style="width: 90%;">
			<h2>
			{{ $t('lang.about1')}}
			</h2>
			<p style="text-indent:2em;text-align: justify;">
			{{ $t('lang.about2')}}
			</p>
			
			<router-link to="technology1" target="_blank">
				<h2>
				{{ $t('lang.about26')}}
				</h2>
				<img src="../../../public/pic/company/about.png" style="width: 100%;">
				<div style="padding: 14px;">
					<p style="text-indent:2em;text-align: justify;text-decoration: underline;">
						{{ $t('lang.about27')}}
					</p>
				</div>
			</router-link>

			<h2>{{ $t('lang.about3')}}</h2>
			<div class="block" style="text-align: left;">
				<el-timeline>
					<el-timeline-item timestamp="2016/08/18" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about4')}}</h1>
							<p >{{ $t('lang.about5')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2016/08/28" placement="top">
						<el-card class="black_background ">
							<h1>{{ $t('lang.about6')}}</h1>
							<p >{{ $t('lang.about7')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2017/06/01" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about8')}}</h1>
							<p >{{ $t('lang.about9')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2017/11/01" placement="top">
						<el-card class="black_background ">
							<h1>{{ $t('lang.about10')}}</h1>
							<p >{{ $t('lang.about11')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2018/05/15" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about12')}}</h1>
							<p >{{ $t('lang.about13')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2018/10/20" placement="top">
						<el-card class="black_background ">
							<h1>{{ $t('lang.about14')}}</h1>
							<p >{{ $t('lang.about15')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2019/06/10" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about16')}}</h1>
							<p>{{ $t('lang.about17')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2019/10/01" placement="top">
						<el-card class="black_background ">
							<h1>{{ $t('lang.about18')}}</h1>
							<p>{{ $t('lang.about19')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2019/12/01" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about20')}}</h1>
							<p >{{ $t('lang.about21')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2020/01/08" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about22')}}</h1>
							<p>{{ $t('lang.about23')}}</p>
						</el-card>
					</el-timeline-item>
					<el-timeline-item timestamp="2020/03/15" placement="top">
						<el-card class="black_background">
							<h1>{{ $t('lang.about24')}}</h1>
							<p>{{ $t('lang.about25')}}</p>
						</el-card>
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	head(){
		return {
			title : '公司简介_深圳全智能机器人科技有限公司  。Company Profile- Shenzhen All Intelligent Technology Co., Ltd.',
			keywords : '消毒机器人,迎宾机器人，陪护机器人,送餐机器人,硅胶实体娃娃,深圳全智能机器人科技有限公司----。Disinfect robots, welcome robots, companion love robots, meal delivery robots, silicone solid dolls, Shenzhen All Intelligent Technology Co., Ltd.',
			description : '全智能科技（AI-Tech）是深圳全智能机器人科技有限公司[Shenzhen All Intelligent Technology Co.，Ltd. ]的简称，沿革于2013年，创建于2016年8月18日。顾名思义，全智能科技（AI-Tech）是以研发、生产、销售人工智能技术服务和产品的国家级高新技术企业。我们利用自主开发的核心技术，以“虚实结合、软硬兼备”的模式，致力于打造实用型的新型人工智能技术和AI科技共享平台。 AI-Tech short for Shenzhen All Intelligent Technology Co.，Ltd. started in 2013 which is a national level high tech company researching, manufacturing, selling AI services and AI products. We leverage self-developed core technologies,combine services with products,software with hardware, dedicating to creat a sharable platform of new pratical AI technology.',
			};
	},
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}

h1{
	color: white;
}

</style>
